<template>
  <v-app v-if="LoginStatus()">
    <v-snackbar
      v-model="snackbarErrorObj.snackbar"
      :color="snackbarErrorObj.color"
      :multi-line="true"
      :timeout="snackbarErrorObj.timeout"
      :top="true"
    >
      {{ snackbarErrorObj.text }}
      <template>
        <v-btn dark text @click="snackbarErrorObj.snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
    <v-navigation-drawer
      v-model="primaryDrawer.model"
      :clipped="primaryDrawer.clipped"
      :permanent="primaryDrawer.type === 'permanent'"
      :temporary="primaryDrawer.type === 'temporary'"
      app
      overflow
    >
      <v-card class="mx-auto" width="300">
        <v-list>
          <v-list-item router-link to="/">
            <v-list-item-icon>
              <v-icon>mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Anasayfa</v-list-item-title>
          </v-list-item>
          <!-- <v-list shaped v-if="loggedAdmin.isSuperAdmin">
            <v-subheader>RAPORLAR</v-subheader>
            <v-list-item-group v-model="item" color="primary">
              <v-list-item
                v-for="(item, i) in items"
                :key="i"
                router-link
                :to="item.route"
              >
                <v-list-item-icon>
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.text"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list> -->
        </v-list>
        <v-list-group value="true">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Kullanıcı İşlemleri</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item router-link to="/userslist">
            <v-list-item-icon>
              <v-icon v-text="'groups'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Kullanıcı Listesi'"></v-list-item-title>
          </v-list-item>
          <v-list-item
            router-link
            to="/companylist"
            v-if="loggedAdmin.isSuperAdmin"
          >
            <v-list-item-icon>
              <v-icon v-text="'business'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Firma Listesi'"></v-list-item-title>
          </v-list-item>
          <v-list-item
            router-link
            to="/reportsTable"
            v-if="loggedAdmin.isSuperAdmin"
          >
            <v-list-item-icon>
              <v-icon> mdi-chart-line</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="'Karşıt İnceleme Rapor'"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-card>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="primaryDrawer.clipped" app>
      <v-app-bar-nav-icon
        v-if="primaryDrawer.type !== 'permanent'"
        @click.stop="primaryDrawer.model = !primaryDrawer.model"
      ></v-app-bar-nav-icon>
      <v-toolbar-title class="text-uppercase grey--text">
        <span class="font-weight-light">KDV</span>
        <span>&nbsp;İADE</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items>
        <v-btn text @click="logOut">Çıkış</v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-content>
      <v-container fluid>
        <v-row align="center" justify="center">
          <router-view />
        </v-row>
      </v-container>
    </v-content>
    <footerView></footerView>
  </v-app>
  <v-app v-else>
    <v-snackbar
      v-model="snackbarErrorObj.snackbar"
      :color="snackbarErrorObj.color"
      :multi-line="true"
      :timeout="snackbarErrorObj.timeout"
      :top="true"
    >
      {{ snackbarErrorObj.text }}
      <template>
        <v-btn dark text @click="snackbarErrorObj.snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
    <router-view />
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data: () => ({
    loginStatus: false,
    drawer: false,
    drawers: ["Default (no property)", "Permanent", "Temporary"],
    primaryDrawer: {
      model: null,
      type: "default (no property)",
      clipped: true,
    },
    item: 1,
    items: [
      // {
      //   text: "Kullanıcı Bilgilendirme",
      //   icon: "mdi-clock",
      //   route: "/information",
      // },
      // {
      //   text: "Sorular Ve İstekler",
      //   icon: "mdi-message",
      //   route: "/questionandrequest",
      // },
    ],
    text: "",
  }),
  methods: {
    ...mapActions(["changeLoginStatus"]),
    logOut() {
      this.changeLoginStatus({
        isSuperAdmin: false,
        isLoggedIn: false,
        token: null,
      });
      localStorage.clear();
      this.$router.push("/adminlogin");
    },
    LoginStatus() {
      return this.loggedAdmin.isLoggedIn;
    },
    handler(event) {
      console.log(event);
      alert(JSON.stringify(this.loggedAdmin));
    },
  },
  computed: {
    ...mapState(["snackbarErrorObj", "loggedAdmin"]),
  },
  created() {
    window.addEventListener("beforeunload", this.handler);
    this.LoginStatus();
  },
  updated() {
    this.LoginStatus();
  },
};
</script>
